import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jinherit(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
    <Sides/>
    <Helmet>
 
 <title>Master the Art of Java Inheritance: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content=" Learn the main concept of OOP with CodeExampler's beginner Java inheritance tutorial. Create parent and child classes with ease." />
<meta name="keywords" content="Java inheritance, Java inheritance example,java inheritance interview questions,order of execution of constructors in java inheritance is Java inheritance types, Java inheritance and polymorphism,java inheritance practice problems pdf, CodeExampler" />
<link rel="canonical" href="https://www.codeexampler.com/java-inheritance" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">What is Inheritance in Java</h1>
    <div className="first">
        <a href="/java-constructor">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-single-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, Inheritance in java is important because it supports the concept of hierarchical classification<br/>
2, Inheritance is the main concept of oops by which we can create parent and child class.<br/>
3, Inheritance in java it inherits the property of parent class into child class. This is also known as inheritance<br/>
4, A parent class is a superclass <br/>
</p>

<h2 className="mt-4 mh2">Advantages and Disadvantages of inheritance in java:
</h2>
<h3 className="mt-4 mh3">Advantage in Inheritance :

</h3>

<p className="mt-3 para">1, A child class is a subclass<br/>
2, The main advantage of inheritance is that we can access the member of the superclass directly (without creating an object).<br/>
3, Inheritance is code reusability<br/>
4, Construct can’t inherit in another class because is not the part of the class<br/>
5, The private method can’t call when child class call superclass inside methods<br/>
</p>

<h3 className="mt-4 mh3">Disadvantage in Inheritance:
</h3>
<p className="mt-4 para">1, Inheritance give tightly coupled means after use extends   between two class are tightly coupled  occupy more space or memory<br/>
2, for the reason of tightly coupled, when you change inside any class so show changes in another class<br/>
</p>
<h2 className="mt-4 mh2">
inheritance basics in java:
</h2>
<p className="mt-4 para">you can access the member of the superclass directly by the use of extends keyword means subclass adds to the superclass by using extend keyword. and this inheritance in java interview questions put up in many MNC companies.
</p>

<h2 className="mt-4 mh2">This is inheritance IS-A relationship in java:
</h2>


<h2 className='headings'>Syntax of Inheritance in Java:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty">Teacher </span>
                <span className="qwerty-2">IS</span>
                <span className="qwerty-1">-</span>
                <span className="qwerty-4">A </span>
                <span className="qwerty-7">students</span>
            
                {"\n"}{"\n"}      
        </code>
        </pre>
        </div>  



<h2 className='headings'>Q-Write a program Example of inheritance in Java?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty">class </span>
                <span className="qwerty-4">students </span>
                <span className="qwerty-5">//superclass or parent class</span>
            {"\n"}
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-3">  void </span>
                <span className="qwerty-8">learn</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                <span className="qwerty-6">    System.out.println</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">This is a students</span>
                <span className="qwerty-1">")</span>
                <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-1" >  &#125;</span>
            {"\n"}
                <span className="qwerty-1" >&#125;</span>
            {"\n"}
                <span className="qwerty">class </span>
                <span className="qwerty-7">teachers </span>
                <span className="qwerty-2">extends </span>
                <span className="qwerty-4">students </span>
                <span className="qwerty-5">//teachers is a child class </span>
            {"\n"}
                <span className="qwerty-1" >&#123;</span>
            {"\n"}
                    <span className="qwerty-7">   public </span>
                    <span className="qwerty">static </span>
                    <span className="qwerty-3">void </span>
                    <span className="qwerty-8">main</span>
                    <span className="qwerty-1">(</span>
                    <span className="qwerty-2">String</span>
                    <span className="qwerty-6">[]</span>
                    <span className="qwerty-4">args</span>
                    <span className="qwerty-1">)</span>
            {"\n"}
                <span className="qwerty-1" >    &#123;</span>
            {"\n"}
                    <span className="qwerty-7">        teachers </span>
                    <span className="qwerty-5">t</span>
                    <span className="qwerty-1"> = </span>
                    <span className="qwerty">new </span>
                    <span className="qwerty-7">teachers</span>
                    <span className="qwerty-10">()</span>
                    <span className="qwerty-1">;</span>
            {"\n"}
                <span className="qwerty-5">        t</span>
                <span className="qwerty-1">.</span>
                <span className="qwerty-8">learn</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1">;</span>        
                    {"\n"}          
                         <span className="qwerty-1" >    &#125;</span>
                    {"\n"}          
                         <span className="qwerty-1" >&#125;</span>
                {"\n"}{"\n"}      
        </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-2">This is a students</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>


<h2 className="mt-4 mh2">There are 5 types of inheritance in java:
</h2>

<h3 className="mt-4 mh3">1, Single inheritance in java<br/>
2, Multilevel inheritance in java<br/>
3, Hierarchical inheritance in java<br/>
4, Multiple inheritances in java<br/>
5, Hybrid inheritance in java<br/>
</h3>

<h2 className="mt-4 mh2">But inside java use only 3 types of inheritance : </h2>

<h3 className="mt-4 mh3">1, Single inheritance in java<br/>
2, Multilevel inheritance in java<br/>
3, Hierarchical inheritance in java
</h3>
  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/java-constructor">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-single-inheritance">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jinherit;